import {
  CREATEFEEWALLET_SUCCESS,
  CREATEFEEWALLET_FAILED,
  RESET_CREATEFEEWALLET,
  LOADING_CREATEFEEWALLET,
  NETWORK_ERROR_CREATEFEEWALLET,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_CREATEFEEWALLET:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case CREATEFEEWALLET_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case CREATEFEEWALLET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_CREATEFEEWALLET:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_CREATEFEEWALLET:
      return (state = initialState);
    default:
      return state;
  }
};
